import React from 'react';

function UbiCel ({fondo}) {

  return (
        <section className="ubicacionCel">
            <img loading="lazy" className="fondoCel" src={fondo.url} alt="..." />
        </section>
  );
}

export default UbiCel;
